import { useEffect } from 'react'

import { useDataBoxSelector } from 'app/common/data-box-store'
import PlainItemsSelectorBox from 'app/common/ui-next/_filter-compilations/plain-items-selector-box'
import { OrgType } from 'app/dataTypes/org'

import {
  classTypeFilter,
  classTypeFilterSelection,
  orgsFilterSelection,
  orgTypesFilterSelection,
} from 'app/dataProviders/filter-items'

type Props = { id: string; pending: boolean }

export const ClassTypeFilter = ({ id, pending }: Props) => {
  const orgType = useDataBoxSelector(orgTypesFilterSelection, () => orgTypesFilterSelection.data)
  const selectedOrgs = useDataBoxSelector(orgsFilterSelection, () => orgsFilterSelection.data)

  const visible = orgType[0] === OrgType.School && selectedOrgs.length === 1

  useEffect(() => {
    classTypeFilterSelection.resetToDefault()
  }, [selectedOrgs])

  useEffect(() => {
    if (!visible) classTypeFilterSelection.resetToDefault()
  }, [visible])

  if (!visible) return null

  return (
    <PlainItemsSelectorBox
      id={id}
      label="Тип класса"
      header="Выбор типа класса"
      dataBoxData={classTypeFilter}
      dataBoxSelection={classTypeFilterSelection}
      pleaseSelectText="Нет данных"
      selectedAllOnEmptySelection
      disabled={pending}
    />
  )
}
